// @flow
import React, { Component, Fragment } from 'react'
import AdEditContainer from './AdEditContainer'
import SwitchableProviderPreviewContainer from './AdEdit/SwitchableProviderPreviewContainer'
import PrimaryButton from './controls/PrimaryButton'
import FloatPanel from './controls/FloatPanel'
import styled, { type StyledComponent } from 'styled-components'
import _ from 'lodash'
import type { AudienceData, Configs, UrlCheckResult, OptionType } from './types'

export const PanelHint: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  margin: 0 0 0 20px;
  font-size: 14px;
  color: #000;
  line-height: 40px;
`
const ButtonsWrapper: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -5px;
`
const StyledPrimaryButton: StyledComponent<Object, any, any> = styled(PrimaryButton)`
  margin-left: 5px;
`

type ReadyProps = {|
  action: 'copy' | 'update' | 'create',
  onInit: () => void,
  onChange: Function,
  maxMediaCount: number,
  storeIds: Array<string>,
  onAdvertisementChange: Function,
  audienceData: AudienceData,
  configs: Configs,
  urlCheck: ?UrlCheckResult,
  fbPromotionPosts: Array<OptionType>,
  isLoading: boolean,
  onPersist: (string) => void,
  isPromotionUrlEditDisabled: boolean
|}

type Props = ReadyProps & {
  ownProps?: { audienceData: AudienceData }
}

const t = {
  submit_text: {
    inactive: 'Создать остановленными',
    copy: 'Скопировать объявление',
    update: 'Сохранить изменения',
    create: 'Разместить объявления'
  },
  submit_hint: 'Объявление будет повторно отправлено на модерацию'
}

export default class AdEditWrapper extends Component<Props> {
  constructor(props: Props) {
    super(props)

    const { onInit, onChange, ownProps } = props

    ownProps && onChange({ providers: ownProps.audienceData.providers })
    onInit()

    window.adEditWrapperComponent = this // for tests
  }

  static defaultProps = {
    maxMediaCount: 1
  }

  render() {
    const {
      storeIds,
      onAdvertisementChange,
      maxMediaCount,
      configs,
      audienceData,
      urlCheck,
      action,
      fbPromotionPosts
    } = this.props

    return (
      <Fragment>
        {_.map(storeIds, (storeId) => {
          return (
            <AdEditContainer
              key={storeId}
              configs={configs}
              audienceData={audienceData}
              storeId={storeId}
              maxMediaCount={maxMediaCount}
              onChange={(diff) => onAdvertisementChange(storeIds, diff)}
              isPromotionUrlEditDisabled={this.props.isPromotionUrlEditDisabled}
              urlCheck={urlCheck}
              action={action}
              fbPromotionPosts={fbPromotionPosts}
            />
          )
        })}
        <SwitchableProviderPreviewContainer audienceData={audienceData} storeIds={storeIds} />
        {!this.props.isPromotionUrlEditDisabled && (
          <FloatPanel>{this.renderPanelContent()}</FloatPanel>
        )}
      </Fragment>
    )
  }

  renderPanelContent() {
    return (
      <ButtonsWrapper className="container">
        {this.renderPostButton(t.submit_text[this.props.action], 'active')}
        {this.props.action !== 'update' &&
          this.renderPostButton(t.submit_text.inactive, 'inactive')}
        {this.props.action === 'update' && <PanelHint>{t.submit_hint}</PanelHint>}
      </ButtonsWrapper>
    )
  }

  renderPostButton(text: string, status: string) {
    return (
      <StyledPrimaryButton
        height={32}
        disabled={this.props.isLoading}
        onClick={() => this.props.onPersist(status)}
      >
        {text}
        {this.props.isLoading && ' ...'}
      </StyledPrimaryButton>
    )
  }
}
